import { GetAllSectorsParams } from 'domain/models';
import { useEffect, useState } from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';

interface Props {
  paginationStatus: GetAllSectorsParams['status'];
  handleStatusChange: (status: GetAllSectorsParams['status']) => void;
  disabled?: boolean;
}

export const DropdownSectorsStatus = ({
  paginationStatus,
  handleStatusChange,
  disabled = false,
}: Props) => {
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);

  const options: { label: string; value: GetAllSectorsParams['status'] }[] = [
    { label: 'Todos', value: 'ALL' },
    { label: 'Ativos', value: 'ACTIVE' },
    { label: 'Inativos', value: 'INACTIVE' },
  ];

  const toggleDropdown = () => {
    if (disabled) return;

    setIsStatusDropdownOpen((prev) => !prev);
  };

  const handleSelectStatus = (status: GetAllSectorsParams['status']) => {
    setIsStatusDropdownOpen(false);

    if (disabled || status === paginationStatus) return;

    handleStatusChange(status);
  };

  useEffect(() => {
    if (disabled) {
      setIsStatusDropdownOpen(false);
    }
  }, [disabled]);

  return (
    <Dropdown isOpen={isStatusDropdownOpen} toggle={toggleDropdown}>
      <DropdownToggle
        tag="button"
        type="button"
        disabled={disabled}
        className="btn btn-link text-muted text-decoration-none p-0 border-0 shadow-none"
      >
        {options.find((option) => option.value === paginationStatus)?.label ??
          'Todos'}
        <i className="ri-arrow-down-s-line ms-1" />
      </DropdownToggle>

      <DropdownMenu end>
        {options.map((option) => (
          <DropdownItem
            key={option.value}
            active={paginationStatus === option.value}
            disabled={disabled}
            onClick={() => handleSelectStatus(option.value)}
          >
            {option.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};
